import React, {
    useState,
    useEffect,
} from "react";
import {
    Row,
    Col,
    Modal
} from "react-bootstrap";
import { Bars } from "react-loader-spinner";
import { CustomButton } from "../../../../reusable-components/CustomButtonComponent/button";

export const ApproveModal = (props) => {
    const [validationProgress, setValidationProgress] = useState(props.validationapiprogress)
    useEffect(() => {
        setValidationProgress(props.validationapiprogress)
    }, [props.validationapiprogress])

    const [saveProgress, setSaveProgress] = useState(props.saveapiprogress)
    useEffect(() => {
        setSaveProgress(props.saveapiprogress)
    }, [props.saveapiprogress])

    const [approvalProgress, setApprovalProgress] = useState(props.approvalapiprogress)
    useEffect(() => {
        setApprovalProgress(props.approvalapiprogress)
    }, [props.approvalapiprogress])

    const [validationStatus, setValidationStatus] = useState(props.validationstatus)
    useEffect(() => {
        setValidationStatus(props.validationstatus)
    }, [props.validationstatus])

    const [validationIssues, setValidationIssues] = useState(props.validationissues)
    useEffect(() => {
        setValidationIssues(props.validationissues)
    }, [props.validationissues])

    const [validationErrorFields, setValidationErrorFields] = useState(props.validationerrorfields)
    useEffect(() => {
        setValidationErrorFields(props.validationerrorfields)
    }, [props.validationerrorfields])

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="custom-backdrop"
            backdrop="static"
            centered
            scrollable="false"
            style={{
                maxHeight: 500,
                overflow: "auto",
                top: "20%"
            }}
        >
            <Modal.Header>
                {
                    validationProgress === undefined && saveProgress === undefined
                        ?
                        <h6 style={{ marginBottom: 0, marginRight: 20 }}>Are you sure you want to approve these changes?</h6>
                        :
                        <></>
                }
                {/* Please note that this response will be approved and would be used to send to TAX. */}
                {
                    saveProgress === true
                        ?
                        <div style={{ width: "fit-content", position: "relative" }}>
                            <Bars
                                height="40"
                                width="40"
                                color="var(--theme1_primary)"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                            <h6 style={{ marginBottom: 0, marginRight: 20 }}>Saving your response ...</h6>
                        </div>
                        :
                        <></>
                }
                {
                    saveProgress !== undefined && validationProgress === true
                        ?
                        <div style={{ width: "fit-content", position: "relative" }}>
                            <Bars
                                height="40"
                                width="40"
                                color="var(--theme1_primary)"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                            <h6 style={{ marginBottom: 0, marginRight: 20 }}>Validating your response...</h6>
                        </div>
                        :
                        <></>
                }
                {
                    validationStatus === false
                        ?
                        <Row>
                            <Col md={12}>
                                <h6 style={{ marginBottom: 0, marginRight: 20 }}>There are validation errors in you response.</h6>
                            </Col>
                            <br /><br />
                            <Col md={12}>{
                                Object.entries(validationErrorFields).map(([page, field]) => (

                                    <>On {page}, validation failed for the following fields:
                                        <ul>{
                                            String(field).split(':')[1].split(',').map((f) => (
                                                <li>• {f}</li>
                                            ))
                                        }</ul>
                                        <>{validationIssues[page].split("\n")[0]} </><br />
                                        <>{validationIssues[page].split("\n")[1]}</>

                                    </>
                                ))
                            }
                                <br /><br />
                            </Col>
                            <Col md={12}>
                                <h6>Do you want to override and continue or fix the response?</h6>
                            </Col>
                        </Row>
                        :
                        <></>
                }
                {
                    validationStatus === true
                        ?
                        <h6 style={{ marginBottom: 0, marginRight: 20 }}>The reponse is saved and validated. Please continue to approve.</h6>
                        :
                        <></>
                }
            </Modal.Header>
            <Modal.Footer className="flex-row-space-center" style={{ padding: "0px 10px" }}>
                {validationStatus === undefined && saveProgress === undefined && validationProgress === undefined
                    ?
                    <>
                        <CustomButton
                            progress={saveProgress && validationProgress}
                            onclick={() => {
                                props.submit()
                            }}
                            content={"Save & Validate"}
                            disable={false}
                        />
                        <CustomButton
                            progress={false}
                            onclick={() => props.onHide()}
                            content={"Cancel"}
                            disable={false}
                        />
                    </> :
                    <></>}
                {
                    validationStatus !== undefined &&
                    <>
                        <CustomButton
                            progress={approvalProgress}
                            onclick={() => {
                                props.approvedata()
                                props.onHide()
                            }}
                            content={validationStatus === true ? "Approve" : "Override"}
                            disable={false}
                        />
                        <CustomButton
                            progress={false}
                            onclick={() => props.onHide()}
                            content={"Cancel"}
                            disable={false}
                        />
                    </>
                }
            </Modal.Footer>
        </Modal>
    )
}